// Global messaging
export const PENDO_NOT_AVAILABLE_MSG: string = 'Pendo is not available in this environment.';

// Guide IDs
export const PENDO_RESOURCE_CENTER_GUIDE_ID: string = '22vS2kqLj3AuLiJqHyYWHDlhOdU';
export const PENDO_GIVE_FEEDBACK_GUIDE_ID: string = 'De6B0gsXLDNrKp4IciGv9yeP4vA';

// Event names
export const PENDO_EDITING_DATA_PAGE_CELL_EVENT: string = 'editing data page cell';
